import { useDispatch, useSelector } from "react-redux";
import { ApiStatus } from "../types/api/status";
import { CustomSnackbar } from "../components/common/CustomSnackbar/CustomSnackbar";
import { changeStatus, onChangeIsEdit, onFetchTeachers, onFetchTeachersWeb, onSetEditTeacherWeb, onSetOpenModal, onSetSelectedTeacher, onSetSelectedTeacherWeb, selectTeacherWebState } from "../redux/slices/teacherWebSlice";
import { TeacherWebAPI } from "../apis/TeacherWebAPI";
import { Teacher, TeacherWeb, TeacherWebCreateEdit } from "../types/slices/teachersWebType";

export const useTeacherWebStore = () => {
  const dispatch = useDispatch();
  const {
    teachersWeb,
    status,
    openModal,
    isEdit,
    editTeacherWeb,
    selectedTeacherWeb,
    selectedTeacher,
    teachers
  } = useSelector(selectTeacherWebState);

  const getTeachersWeb = async () => {
    try {
      dispatch(changeStatus(ApiStatus.FETCHING));
      const response = await TeacherWebAPI.getTeachersWeb();
      if (!response?.status) {
        dispatch(changeStatus(ApiStatus.FETCHED));
        return CustomSnackbar("error", response.data.message || "");
      }
      const { detail } = response.data;
      dispatch(onFetchTeachersWeb(detail));
      dispatch(changeStatus(ApiStatus.FETCHED));
    } catch (error) {
      console.log(error);
      return dispatch(changeStatus(ApiStatus.FETCHED));
    }
  };

  const getTeachersWebSearch = async (term) => {
    try {
      dispatch(changeStatus(ApiStatus.FETCHING));
      const response = await TeacherWebAPI.getTeachersWebSearch(term);
      if (!response?.status) {
        dispatch(changeStatus(ApiStatus.FETCHED));
        return CustomSnackbar("error", response.data.message || "");
      }
      const { detail } = response.data;
      dispatch(onFetchTeachersWeb(detail));
      dispatch(changeStatus(ApiStatus.FETCHED));
    } catch (error) {
      console.log(error);
      return dispatch(changeStatus(ApiStatus.FETCHED));
    }
  };

  const createTeacherWebStore = async (data: any) => {
    try {
      dispatch(changeStatus(ApiStatus.FETCHING));
      const response = await TeacherWebAPI.createTeacherWeb(data);
      if (!response?.status) {
        dispatch(changeStatus(ApiStatus.FETCHED));
        return CustomSnackbar("error", response.data.message || "");
      }
      dispatch(changeStatus(ApiStatus.FETCHED));
      CustomSnackbar("success", response.data.message || "");
      return true;
    } catch (error) {
      console.log(error);
      return dispatch(changeStatus(ApiStatus.FETCHED));
    }
  };

  const editTeacherWebStore = async (id: number, data: any) => {
    try {
      dispatch(changeStatus(ApiStatus.FETCHING));
      const response = await TeacherWebAPI.editTeacherWeb(id, data);
      if (!response?.status) {
        dispatch(changeStatus(ApiStatus.FETCHED));
        return CustomSnackbar("error", response.data.message || "");
      }
      dispatch(changeStatus(ApiStatus.FETCHED));
      CustomSnackbar("success", response.data.message || "");
      return true;
    } catch (error) {
      console.log(error);
      return dispatch(changeStatus(ApiStatus.FETCHED));
    }
  };

  const deleteTeacherWebStore = async (id: number) => {
    try {
      dispatch(changeStatus(ApiStatus.FETCHING));
      const response = await TeacherWebAPI.deleteTeacherWeb(id);
      if (!response?.status) {
        dispatch(changeStatus(ApiStatus.FETCHED));
        CustomSnackbar("error", response.data.message || "");
        return false;
      }
      dispatch(changeStatus(ApiStatus.FETCHED));
      CustomSnackbar("success", response.data.message || "");
      return true;
    } catch (error) {
      console.log(error);
      return dispatch(changeStatus(ApiStatus.FETCHED));
    }
  };

  const setSelectedTeacherWeb = (teacher: TeacherWeb) => {
    try {
      dispatch(onSetSelectedTeacherWeb(teacher));
    } catch (error) {
      console.log(error);
    }
  };

  const getTeacher = async () => {
    try {
      dispatch(changeStatus(ApiStatus.FETCHING));
      const response = await TeacherWebAPI.getTeacher();
      if (!response?.status) {
        dispatch(changeStatus(ApiStatus.FETCHED));
        return CustomSnackbar("error", response.data.message || "");
      }
      const { detail } = response.data;
      dispatch(onFetchTeachers(detail));
      dispatch(changeStatus(ApiStatus.FETCHED));
    } catch (error) {
      console.log(error);
      return dispatch(changeStatus(ApiStatus.FETCHED));
    }
  };

  const setSelectedTeacher = (teacher: Teacher) => {
    try {
      dispatch(onSetSelectedTeacher(teacher));
    } catch (error) {
      console.log(error);
    }
  };

  const setEditTeacherWeb = (teacher: TeacherWebCreateEdit) => {
    try {
      dispatch(onSetEditTeacherWeb(teacher));
    } catch (error) {
      console.log(error);
    }
  };

  const setOpenModal = (status: boolean) => {
    try {
      dispatch(onSetOpenModal(status));
    } catch (error) {
      console.log(error);
    }
  };

  const changeIsEdit = (status: boolean) => {
    try {
      dispatch(onChangeIsEdit(status));
    } catch (error) {
      console.log(error);
    }
  };

  return {
    // states
    teachersWeb,
    status,
    editTeacherWeb,
    selectedTeacherWeb,
    selectedTeacher,
    teachers,
    openModal,
    isEdit,
    // actions
    getTeacher,
    getTeachersWeb,
    setOpenModal,
    setEditTeacherWeb,
    setSelectedTeacherWeb,
    setSelectedTeacher,
    changeIsEdit,
    getTeachersWebSearch,
    createTeacherWebStore,
    editTeacherWebStore,
    deleteTeacherWebStore,
  };
};